import {
  Directive,
  ElementRef,
  Input,
  OnInit,
  effect,
  inject,
} from '@angular/core';

import { CalenderEventCategories } from 'src/app/core/api/models';
import { CalendarEventsService } from './calendar-events.service';

@Directive({
  selector: '[calendarEventDisplayer]',
  standalone: true,
})
export class CalendarEventDisplayerDirective implements OnInit {
  calendarEventsService = inject(CalendarEventsService);

  @Input('calendarEventDisplayer') eventCategory: CalenderEventCategories;
  constructor(private element: ElementRef<HTMLElement>) {
    effect(() => {
      if (
        !this.calendarEventsService
          .selectedCategories()
          .includes(this.eventCategory)
      )
        this.element.nativeElement.classList.add('d-none');
      else this.element.nativeElement.classList.remove('d-none');
    });
  }

  ngOnInit(): void {}
}
